// DEVELOPMENT | PRODUCTION | OFFLINE
ENV = 'PRODUCTION';

CONFIG = {
	appType: 'ALLFLAMENCO',  // application type: ALLFLAMENCO
	locale: 'SP',
	versionSDK: '2.0.217 [19.10.2015]',  // SDK version  (format: X.Y.SDK_SVN_Revision_number)
	version: '1.0.20', // application version - put your own 23.5.2017
	developer: {
		debug: false,
		active: false,
		console: null,
		pin: '99999' // show short info about application
	},
	apiUrl: 'https://app.allflamenco.net',
	subtitlesUrl: 'https://app.allflamenco.net',
	imageResizerUrl: 'https://allflamenco-assets.s3.amazonaws.com', // server for resizing images
	player: {
		muted: false
	},
	network: true, // true if app should check the network connectivity
	ajax: {
		timeout: 60000
	},
	appErrTimeout: 180000,
	keyboard: {
		oneLayout: false
	},
	api: {
		url:'.'
	},
	coverAnimationTimeout: 1500, // ms time when focused cover be animated
	mouse:{
		modeArrows: 'auto', // mode of showing arrows: on/off/auto   // auto -> arrows will be showed automatically (after Mouse moving is detected)
		hideArrows: 15000, // how long can be arrows visible, used only for mode='auto' [ms]
		rightIsReturn: false // set mouse right click to press Return/Back key on RC
	},
	GA: {
		account: '', // account number for Google Analytics
		ssl: true
	},

	isPlayable: true,   // can play videos
};

if(CONFIG.appType === 'ALLFLAMENCO') {
	CONFIG.bodyClass = 'allflamenco';
	CONFIG.usbFolderName =  'allflamenco';
}

if (ENV == 'PRODUCTION') {
	CONFIG.developer.debug = false;
	CONFIG.developer.active = false;

	CONFIG.mouse.rightIsReturn = true;
}
else if (ENV == 'DEVELOPMENT') {
	CONFIG.developer.debug = true;
	CONFIG.developer.active = true;
}
else if (ENV == 'OFFLINE') {
	CONFIG.developer.debug = false;
	CONFIG.developer.active = false;

	CONFIG.network = false;
	CONFIG.api.url = CONFIG.usbFolderName; // folder, where offline data are available (usb path + CONFIG.api.url + '/dummyData/'+ real content)

	CONFIG.mouse.rightIsReturn = false;
}


//////////////////
// WEBPACK FOOTER
// ./prod.config.js
// module id = 104
// module chunks = 0